/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `KOMPLETNI` - Kompletní data PSPI
 *   * `VEREJNE_FINANCOVANI` - PSPI z veřejných zdrojů
 * ```
 */
export const PspiObsahEnum = {
  KOMPLETNI: 'KOMPLETNI',
  VEREJNE_FINANCOVANI: 'VEREJNE_FINANCOVANI',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PspiObsahEnum = ValuesOf<typeof PspiObsahEnum>;

export type PspiObsahEnumRequest = PspiObsahEnum;
export type PspiObsahEnumResponse = PspiObsahEnum;
